import { toLogFmt } from '@w/utils'
import { toRequestId } from './basic-otel-compat.js'

import { toOtelSpanId } from './basic-otel-compat.js'

import type { OtelResource } from './basic-otel-compat.js'
import { type TelErrorData, telErrorDataToTags } from './tel-error-data.js'
import type { TelStorageEventHandlers } from './tel-storage.js'

export function prepareSentryHint(
  resource: OtelResource,
  data: TelErrorData,
  user: { id?: string; companyId?: string },
) {
  return {
    user: {
      id: user.id,
      username: user.companyId,
    },
    tags: telErrorDataToTags(data),
    contexts: {
      app: {
        app_name: resource.name,
        app_version: resource.version,
      },
      trace: {
        span_id: toOtelSpanId(data.spanId),
        trace_id: toRequestId(data),
      },
    },
  }
}

export function preparePosthogHint(
  resource: OtelResource,
  data: TelErrorData,
  user: { id?: string; companyId?: string },
) {
  return {
    user: toLogFmt({
      id: user.id,
      companyId: user.companyId,
    }),
    span: toLogFmt({
      name: data.spanName,
      id: toOtelSpanId(data.spanId),
    }),
    traceId: toRequestId(data),
    code:
      data.origin === 'client'
        ? data.serverStatus
        : toLogFmt({
            status: data.status,
            causeStatus: data.causeStatusCode,
          }),
    app: toLogFmt({
      name: resource.name,
      version: resource.version,
    }),
    allData: data,
  }
}

export function makeFakeSentryExport(): TelStorageEventHandlers {
  return {
    errors: {
      onCreate: (data, _error, user) => {
        const hints = prepareSentryHint(
          { name: '', version: '', env: 'fakeSentryExport' },
          data,
          user,
        )
        const hintsToLog = {
          traceId: hints.contexts.trace.trace_id,
          spanId: hints.contexts.trace.span_id,
        }
        console.error(red('sentry error'), toLogFmt(hintsToLog))
        console.error(data)
      },
    },
  }
}

// @ts-ignore
const isBrowser = typeof window !== 'undefined'
const red = (str: string) => (isBrowser ? str : `\x1b[31m${str}\x1b[0m`)
